import { useEffect, useState, useRef } from "react";
import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import AgeGate from "@/components/site/AgeGate";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import ProductShowcase from "@/components/site/ProductShowcase";
import Gallery from "@/components/site/Gallery";
import StoreLocator from "@/components/site/StoreLocator";
import WhereToBuy from "@/components/site/WhereToBuy";
import Preorder from "@/components/site/Preorder";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Socials from "@/components/site/Socials";
import Footer from "@/components/site/Footer";

function App() {
  const [verified, setVerified] = useState(false);
  const lenisRef = useRef(null);

  useEffect(() => {
    window.__lenis = lenisRef.current?.lenis;
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("enter") === "1" || localStorage.getItem("hpg_age_ok") === "true") {
      setVerified(true);
    }
  }, []);

  const handleVerify = () => {
    localStorage.setItem("hpg_age_ok", "true");
    setVerified(true);
  };

  // Lock scroll + hide content from interaction while the 21+ gate is up.
  // Content still renders in the DOM so crawlers can read the page.
  useEffect(() => {
    const lenis = lenisRef.current?.lenis;
    if (!verified) {
      document.body.style.overflow = "hidden";
      lenis?.stop();
    } else {
      document.body.style.overflow = "";
      lenis?.start();
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [verified]);

  return (
    <ReactLenis root ref={lenisRef} options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App bg-ink text-foreground font-body min-h-screen antialiased overflow-x-hidden">
        <div className="grain-overlay" aria-hidden="true" />
        <Toaster theme="dark" position="top-center" richColors />

        {!verified && <AgeGate onVerify={handleVerify} />}

        <div aria-hidden={!verified} className={!verified ? "pointer-events-none select-none" : ""}>
          <Navbar />
          <main>
            <Hero />
            <Marquee />
            <Manifesto />
            <ProductShowcase />
            <Gallery />
            <StoreLocator />
            <WhereToBuy />
            <Preorder />
            <FAQ />
            <Contact />
            <Socials />
          </main>
          <Footer />
        </div>
      </div>
    </ReactLenis>
  );
}

export default App;
